module.exports = __webpack_public_path__ + "img/Taco Icon - white.8ecf2ed3.svg";